import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Layout from './components/common/Layout';
import Login from './components/auth/Login';
import PasswordReset from './components/auth/PasswordReset';
import Dashboard from './components/dashboard/Dashboard';
import ProfileList from './components/profiles/ProfileList';
import ProfileDetail from './components/profiles/ProfileDetail';
import ProfileForm from './components/profiles/ProfileForm';
import SkillManagement from './components/skills/SkillManagement';
import SkillList from './components/skills/SkillList';
import Search from './components/search/Search';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profiles" element={<ProfileList />} />
            <Route path="/profiles/new" element={<ProfileForm />} />
            <Route path="/profiles/:id" element={<ProfileDetail />} />
            <Route path="/profiles/:id/edit" element={<ProfileForm />} />
            <Route path="/profiles/:id/skills" element={<SkillManagement />} />
            <Route path="/skills" element={<SkillList />} />
            <Route path="/search" element={<Search />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
